var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#0052E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2784 35.5959C40.119 31.8299 37.1711 28.881 33.4041 27.7216V11.3943C33.403 10.0719 32.331 9.00109 31.0097 9H28.798C27.4756 9.00109 26.4048 10.0719 26.4037 11.3943V27.7216C20.122 29.6555 16.5966 36.3146 18.5294 42.5963C20.4621 48.878 27.1223 52.4034 33.4041 50.4706C39.6858 48.5368 43.2111 41.8777 41.2784 35.5959ZM40.0993 41.7037C38.9081 46.359 34.709 49.612 29.9039 49.6021C24.1045 49.6142 19.3935 44.9239 19.3804 39.1246C19.3705 34.3195 22.6235 30.1203 27.2787 28.9292C27.5872 28.8493 27.8038 28.5704 27.8038 28.2521V11.3943C27.8049 10.8463 28.249 10.4012 28.798 10.4001H31.0108C31.5599 10.4012 32.004 10.8453 32.0051 11.3943V28.251C32.0051 28.5704 32.2217 28.8482 32.5301 28.9281C38.1479 30.3664 41.5365 36.086 40.0993 41.7037Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1646 38.4037C35.8376 35.4789 33.5285 33.1699 30.6037 32.8428V11.8001C30.6037 11.414 30.2898 11.1001 29.9037 11.1001C29.5175 11.1001 29.2036 11.414 29.2036 11.8001V32.8428C25.7461 33.23 23.2555 36.3463 23.6427 39.8038C24.0299 43.2613 27.1462 45.7519 30.6048 45.3647C34.0612 44.9786 36.5518 41.8612 36.1646 38.4037ZM29.9037 44.0018C27.1976 44.0018 25.0034 41.8076 25.0034 39.1016C25.0034 36.3955 27.1976 34.2013 29.9037 34.2013C32.6097 34.2013 34.8039 36.3955 34.8039 39.1016C34.8006 41.8066 32.6086 43.9985 29.9037 44.0018Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6043 12.5H34.8042V13.9001H37.6043V12.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6043 15.3003H34.8042V16.7004H37.6043V15.3003Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6043 18.1006H34.8042V19.5007H37.6043V18.1006Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6043 20.9004H34.8042V22.3005H37.6043V20.9004Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6043 23.7007H34.8042V25.1008H37.6043V23.7007Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.6a62cff1.svg";
export { ForwardRef as ReactComponent };